import React from 'react';
import { Box, Typography, Button, Container ,useTheme,useMediaQuery} from '@mui/material';
import { DirectionsBoat as BoatIcon } from '@mui/icons-material';

const NotFound404 = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: !isMobile ? 'row' : 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    textAlign: 'center',

                }}
            >
                <Box margin={4}>
                    <BoatIcon sx={{ fontSize: 100, color: 'primary.main', mb: 2 }} />
                </Box>
                <Box margin={4}>
                    <Typography variant="h1" component="h1" gutterBottom fontWeight={'bold'} color={'primary'}>
                        404
                    </Typography>
                    <Typography variant="h4" component="h2" gutterBottom>
                        PAGE NOT FOUND 
                    </Typography>
                    <Typography variant="body1" paragraph>
                        ขออภัย เราไม่สามารถหาหน้าที่คุณต้องการได้
                    </Typography>
                </Box>
            </Box>
        </Container>
    );
};

export default NotFound404;